import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

const getColor = pct => {
  if (pct >= 85) return '#00d27a';
  if (pct >= 70) return '#f5803e';
  return '#e63757';
};

const MonthlyBreakdownTable = ({ months, data }) => (
  <Table bordered size="sm" style={{ tableLayout: 'fixed' }}>
    <thead>
      <tr>
        {months.map(m => (
          <th key={m} style={{ textAlign: 'center', fontSize: 12, background: '#2c7be5', color: '#fff', padding: '4px' }}>
            {m}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      <tr>
        {data.map((pct, i) => (
          <td key={i} style={{ textAlign: 'center', fontWeight: 600, fontSize: 13, color: getColor(pct), padding: '4px' }}>
            {pct}%
          </td>
        ))}
      </tr>
    </tbody>
  </Table>
);

MonthlyBreakdownTable.propTypes = {
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default MonthlyBreakdownTable;
